export default __webpack_public_path__ + "static/pledge_trees-be3f82ebc9ddf31af70894d9dca95d97.webp";